<template>
    <form
        @submit.prevent="deleteUser"
        :action="url"
        method="post"
        class="p-4 flex justify-between items-center space-x-4 bg-white rounded shadow-lg border-2 border-green-500"
    >
        <heading-2>Delete User</heading-2>

        <loading-button
            :loading="form.processing"
            type="submit"
            class="btn btn-green"
        >
            Delete
        </loading-button>
    </form>
</template>

<script>
import LoadingButton from './shared/LoadingButton'
import Heading2 from './shared/Heading2'
import Form from '@/functions/Form'

export default {
    props: {
        url: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            form: Form()
        }
    },
    methods: {
        deleteUser() {
            if(confirm('Are you sure you want to delete your account?')) {
                this.form.delete(this.url, {
                    onSuccess: ({ redirect_to }) => window.location.assign(redirect_to)
                })
            }
        }
    },
    components: {
        LoadingButton,
        Heading2,
    }
}
</script>
